<template>
  <div :class="$attrs.class">
    <label v-if="!noLabel" :for="id" class="block text-sm font-medium text-gray-700 mb-1">{{ label }}</label>
    <div v-if="select" class="relative">
    <select 
      :id="id" 
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :disabled="disabled"
        :class="[
          transparentMode 
            ? 'form-input appearance-none flex w-full min-w-0 flex-1 resize-none overflow-hidden focus:outline-none focus:ring-0 h-auto placeholder:text-gray-500 p-0 pr-8 text-sm font-normal leading-normal bg-transparent border-none shadow-none' 
            : withBorder
              ? 'form-input appearance-none flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-xl text-[#0e141b] focus:outline-none focus:ring-0 h-14 placeholder:text-[#4e7397] p-4 pr-10 text-base font-normal leading-normal border border-gray-300'
              : 'form-input appearance-none flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-xl text-[#0e141b] focus:outline-none focus:ring-0 h-14 placeholder:text-[#4e7397] p-4 pr-10 text-base font-normal leading-normal border-none',
          { 'text-gray-400': !modelValue && placeholder },
          { 'disabled:bg-white disabled:opacity-70 disabled:cursor-not-allowed': disabled },
          inputClass
        ]"
    >
        <option v-if="placeholder" value="" disabled selected class="text-gray-400">{{ placeholder }}</option>
        <option v-for="option in options" :key="option" :value="option" class="text-gray-900">{{ option }}</option>
      <slot></slot>
    </select>
      <div :class="['pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-gray-700', { 'hidden': hideArrow }]">
        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
      </div>
    </div>
    <textarea
      v-else-if="textarea"
      :id="id"
      v-bind="$attrs"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :disabled="disabled"
      :class="[
        withBorder
          ? resizable
            ? 'form-input flex w-full min-w-0 flex-1 resize-y overflow-y-auto rounded-xl text-[#0e141b] focus:outline-none focus:ring-0 min-h-36 max-h-96 placeholder:text-[#4e7397] p-[15px] text-base font-normal leading-normal border border-gray-300'
            : 'form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-xl text-[#0e141b] focus:outline-none focus:ring-0 min-h-36 placeholder:text-[#4e7397] p-[15px] text-base font-normal leading-normal border border-gray-300'
          : resizable
            ? 'form-input flex w-full min-w-0 flex-1 resize-y overflow-y-auto rounded-xl text-[#0e141b] focus:outline-none focus:ring-0 min-h-36 max-h-96 placeholder:text-[#4e7397] p-[15px] text-base font-normal leading-normal'
            : 'form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-xl text-[#0e141b] focus:outline-none focus:ring-0 min-h-36 placeholder:text-[#4e7397] p-[15px] text-base font-normal leading-normal',
        { 'disabled:bg-white disabled:opacity-70 disabled:cursor-not-allowed': disabled }
      ]"
    ></textarea>
    <input
      v-else
      :id="id"
      :type="type"
      :placeholder="placeholder"
      v-bind="$attrs"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :disabled="disabled"
      :class="[
        transparentMode
          ? 'form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden focus:outline-none focus:ring-0 h-auto placeholder:text-gray-500 p-0 text-sm font-normal leading-normal bg-transparent border-none shadow-none'
          : withBorder
            ? 'form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-xl text-[#0e141b] focus:outline-none focus:ring-0 h-14 placeholder:text-gray-400 p-4 text-base font-normal leading-normal border border-gray-300'
          : 'form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-xl text-[#0e141b] focus:outline-none focus:ring-0 h-14 placeholder:text-gray-400 p-4 text-base font-normal leading-normal border-none',
        { 'disabled:bg-white disabled:opacity-70 disabled:cursor-not-allowed': disabled },
        inputClass
      ]"
    >
  </div>
</template>

<script>
export default {
  name: 'FormField',
  props: {
    label: String,
    modelValue: [String, Number],
    id: String,
    type: {
      type: String,
      default: 'text'
    },
    textarea: Boolean,
    select: Boolean,
    options: {
      type: Array,
      default: () => []
    },
    placeholder: String,
    noLabel: Boolean,
    hideArrow: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputClass: [String, Object, Array],
    transparentMode: {
      type: Boolean,
      default: false
    },
    withBorder: {
      type: Boolean,
      default: false
    },
    resizable: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: none;
}

select::-ms-expand {
  display: none;
}
</style>